export const allCalculationMethods = [
    {id: 1, name: "University of Islamic Sciences, Karachi"},
    {id: 2, name: "Islamic Society of North America (ISNA)"},
    {id: 3, name: "Muslim World League (MWL)"},
    {id: 4, name: "Umm al-Qura, Makkah"},
    {id: 5, name: "Egyptian General Authority of Survey"},
    {id: 6, name: "Institute of Geophysics, University of Tehran"},
    {id: 0, name: "Ithna Ashari"},
];
export const allAsrJuristicMethods = [
    {id: 0, name: "Shafii (standard)"},
    {id: 1, name: "Hanafi"},
];